

import {InvoiceLines} from "./invoiceLines";

export class Invoice {

  constructor (

    public $key               :string,
    public amount_due         :number,
    public attempt_count      :number,
    public attempted          :boolean,
    public billing            :string,
    public closed             :boolean,
    public created_on         :string,
    public currency           :string,
    public customer           :string,
    public date               :number,
    public ending_balance     :number,
    public id                 :string,
    public forgiven           :boolean,
    public lines              :InvoiceLines,
    public livemode           :boolean,
    public number             :string,
    public object             :string,
    public paid               :boolean,
    public period_end         :string,
    public period_start       :string,
    public starting_balance   :number,
    public subscription       :string,
    public subtotal           :number,
    public total              :number



){};

  static fromJsonList(array):Invoice[]{
     return array.map(json => Invoice.fromJson(json));
  }

  static fromJson({
                    $key,
                    amount_due,
                    attempt_count,
                    attemped,
                    billing,
                    closed,
                    created_on,
                    currency,
                    customer,
                    date,
                    ending_balance,
                    id,
                    forgiven,
                    lines,
                    livemode,
                    number,
                    object,
                    paid,
                    period_end,
                    period_start,
                    starting_balance,
                    subscription,
                    subtotal,
                    total

    }) : Invoice {
      return new Invoice (
        $key,
        amount_due,
        attempt_count,
        attemped,
        billing,
        closed,
        created_on,
        currency,
        customer,
        date,
        ending_balance,
        id,
        forgiven,
        lines,
        livemode,
        number,
        object,
        paid,
        period_end,
        period_start,
        starting_balance,
        subscription,
        subtotal,
        total
      )
    }


}




// WEBPACK FOOTER //
// ./src/app/shared/model/invoice.ts